import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import * as models from '../../models'
import { getElements } from '../elements'
import type { Manager } from '../manager'

export const applyApprovedProposalToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.approveProposal.success.observe().pipe(
      // We get the new data
      rxjsUtils.latestFrom(action => {
        const currentChartId = models.Chart.Id.from(
          action.data.request.widgetRefId,
        )
        return {
          currentChartId: rxjs.of(currentChartId),
          data: feature.selectors.getChartData({
            chartId: currentChartId,
          }).asObservable,
        }
      }),
      rxjs.map(({ data, currentChartId }) => {
        const cy = manager.getInstance({ chartId: currentChartId })
        if (!data || !cy) {
          // Can't do anything if the data or cytoscape instance are undefined
          return
        }
        // Replace all elements with the new data
        cy.remove('*')
        cy.add(getElements(data))
        manager.resetLayout({ chartId: currentChartId })
      }),
      rxjs.ignoreElements(),
    ),
)
